import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 9C7 7.89543 7.89543 7 9 7H19C20.1046 7 21 7.89543 21 9V19C21 20.1046 20.1046 21 19 21H9C7.89543 21 7 20.1046 7 19V9ZM19 9H9V19H19V9Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 5C3 3.89543 3.89543 3 5 3H15C15.5523 3 16 3.44772 16 4C16 4.55228 15.5523 5 15 5L5 5V15C5 15.5523 4.55228 16 4 16C3.44772 16 3 15.5523 3 15V5Z",
		fill: "currentColor"
	})]
});
export default SvgCopy;
